import React, { useMemo } from 'react';
import { FaInstagram, FaTelegram, FaWhatsapp } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import MenuSection from './MenuSection';
import { buildMenuSections } from './menuConfig';
import { WHATSAPP_BUTTON_CLASS } from '../../data/socialConfig';
import ChannelLink from '../social/ChannelLink';

// WhatsApp is the main channel; the rest are 44px icon links so the bar fits a 320px drawer
const ICON_CHANNELS = [
  { channel: 'telegram', label: 'Telegram', icon: FaTelegram },
  { channel: 'instagram', label: 'Instagram', icon: FaInstagram },
  { channel: 'x', label: 'X', icon: FaXTwitter },
];

const ChannelBar = ({ onClose }) => (
  <div className="flex items-center gap-2">
    <ChannelLink
      channel="whatsapp"
      placement="menu"
      onClick={onClose}
      className={`btn flex-1 min-w-0 gap-2 whitespace-nowrap text-sm font-semibold px-3 ${WHATSAPP_BUTTON_CLASS}`}
    >
      <FaWhatsapp className="w-5 h-5 shrink-0" aria-hidden="true" />
      WhatsApp
    </ChannelLink>
    {ICON_CHANNELS.map(({ channel, label, icon: Icon }) => (
      <ChannelLink
        key={channel}
        channel={channel}
        placement="menu"
        onClick={onClose}
        aria-label={`Follow us on ${label}`}
        className="shrink-0 w-11 h-11 rounded-xl bg-gray-100 dark:bg-gray-700 flex items-center justify-center text-gray-600 dark:text-gray-200 hover:bg-primary/10 hover:text-primary dark:hover:bg-primary/20 transition-colors"
      >
        <Icon className="w-[18px] h-[18px]" aria-hidden="true" />
      </ChannelLink>
    ))}
  </div>
);

const MenuBody = ({
  onClose,
  onAction,
  darkMode,
  onToggleTheme,
  compactHeader = false,
}) => {
  const sections = useMemo(() => buildMenuSections(), []);

  const sectionList = sections.map((section) => (
    <MenuSection
      key={section.id}
      section={section}
      onClose={onClose}
      onAction={onAction}
      darkMode={darkMode}
      onToggleTheme={onToggleTheme}
    />
  ));

  if (compactHeader) {
    return (
      <>
        <div className="px-3 py-3">{sectionList}</div>
        <div className="p-3 border-t border-gray-200 dark:border-gray-700">
          <ChannelBar onClose={onClose} />
        </div>
      </>
    );
  }

  return (
    <>
      <div className="flex-1 overflow-y-auto overscroll-contain px-3 py-3">
        {sectionList}
      </div>
      <div className="flex-shrink-0 p-3 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-dark">
        <ChannelBar onClose={onClose} />
      </div>
    </>
  );
};

export default MenuBody;
